import React from 'react';
import './BlackberryWebfeatures.scss';
import { FaUsers, FaTruck, FaLock, FaAward } from 'react-icons/fa';

const webfeaturesData = [
    {
        id: 1,
        title: '100% Customer Satisfaction',
        // description: 'We are committed to providing the best possible service to our customers',
        icon: <FaUsers />
    },
    {
        id: 2,
        title: 'Express Delivery',
        // description: 'We stand committed to safely deliver your orders in 3 days*',
        icon: <FaTruck />
    },
    {
        id: 3,
        title: '100% Secure Payment',
        // description: 'You are in safe hands. All your payments are secured by 128 bit encryption',
        icon: <FaLock />
    },
    {
        id: 4,
        title: 'Craftmasnhip',
        // description: 'Excellence in every stitch, quality in every product.',
        icon: <FaAward />
    },
];

const BlackberryWebfeatures = () => {
    return (
        <div className="bb-webfeatures">
            <div className="bb-webfeatures__container">
                <div className="bb-webfeatures__grid">
                    {webfeaturesData.map((feature) => (
                        <div key={feature.id} className="bb-webfeatures__feature">
                            <div className="bb-webfeatures__icon">
                                {feature.icon}
                            </div>
                            <h3 className="bb-webfeatures__feature-title">{feature.title}</h3>
                            {/* <p className="bb-webfeatures__feature-description">{feature.description}</p> */}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BlackberryWebfeatures;